<template>
  <div class="bg-riseup-white call-to-action-frame">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'CallToActionFrame',
};
</script>

<style scoped lang="scss">
.call-to-action-frame {
  border-radius: 4px;
  padding: 16px;
}

</style>
